import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { assetQuery, matrixBlockQuery } from '../../content/query-snippets';
import { CardListing } from '../card-listing';
import { Container, Flex } from '../grid';
import { PageLinkCard } from '../card';
import { BlockHeader } from '../block-header';

const PageListingBlock = ({ heading, viBody, pages }) => {
  const items = useMemo(
    () =>
      pages.map(page => ({
        image: page.gridImage,
        heading: page.title,
        description: page.shortDescription,
        link: page.uri,
      })),
    [pages]
  );
  return (
    <Container variant="featuredContent" my={{ xs: '64px', lg: '120px' }} width="100%" backgroundColor="transparent">
      <Flex width="100%" flexDirection="column" alignItems="center">
        <BlockHeader mb={{ xs: '36px', lg: '56px' }} heading={heading} body={viBody} />
        <Flex width={{ xs: 12 / 12, md: 10 / 12 }} justifyContent="center">
          <CardListing
            items={items}
            CardComponent={PageLinkCard}
            cardAlignment="center"
            cardWidth={{ xs: 6 / 12, lg: 4 / 12 }}
            imageTransformIsRequired
            cardGapX={{ xs: '8px', md: '12px' }}
            cardGapY={{ xs: '32px 0', md: '48px 0' }}
            gutter={{ xs: '-8px', md: '-12px' }}
          />
        </Flex>
      </Flex>
    </Container>
  );
};

PageListingBlock.query = `
... on contentMatrix_pageListingBlock_BlockType {
  ${matrixBlockQuery}
  viBody
  heading
  pages {
    ... on pages_Entry {
      ${assetQuery('gridImage')}
      title
      uri
      shortDescription
    }
  }
}
`;

PageListingBlock.propTypes = {
  heading: PropTypes.string,
  viBody: PropTypes.string,
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      gridImage: PropTypes.shape,
      title: PropTypes.string,
      uri: PropTypes.string,
      shortDescription: PropTypes.string,
    })
  ).isRequired,
};

PageListingBlock.defaultProps = {
  heading: undefined,
  viBody: undefined,
};

export { PageListingBlock };
